import { ReactNode } from 'react';

import { Box, MetricsBox, SquareMarker, tokens } from '@cast/design-system';
import type { MetricsBoxProps } from '@cast/design-system';

const UtilizationMarker = ({ color }: { color?: string }) => {
  return (
    <Box
      sx={{
        width: 12,
        height: 12,
        borderRadius: '2px',
        border: '2px dashed',
        borderColor: color ?? tokens.theme.data.yellow800,
        flexShrink: 0,
      }}
    />
  );
};

type ChartMetricProps = {
  color?: string;
  dashedColor?: string;
  dashedMarker?: boolean;
  disabled?: boolean;
  infoTooltip?: ReactNode;
  label: string;
  onClick?: () => void;
  size?: MetricsBoxProps['size'];
  testId?: string;
  unit?: ReactNode;
  value: ReactNode;
};

export const ChartMetric = ({
  color,
  dashedColor,
  dashedMarker,
  disabled = false,
  infoTooltip,
  label,
  onClick,
  size = 'm',
  testId,
  unit,
  value,
}: ChartMetricProps) => {
  return (
    <MetricsBox
      size={size}
      testId={testId}
      slots={{
        startContent: dashedMarker ? (
          <UtilizationMarker color={dashedColor} />
        ) : color ? (
          <SquareMarker color={color} />
        ) : undefined,
        label,
        infoTooltip,
        value,
        unit,
      }}
      slotProps={{
        root: {
          sx: {
            opacity: disabled ? 0.4 : 1,
            cursor: onClick ? 'pointer' : undefined,
            borderRadius: tokens.theme.radius.sm,
            transition: 'background-color 150ms',
            ...(onClick && {
              '&:hover': {
                backgroundColor: tokens.theme.bg.action.surfaceHover,
              },
            }),
          },
          onClick,
        },
      }}
    />
  );
};
